import { render, staticRenderFns } from "./policyDetail.vue?vue&type=template&id=e9adbf64&scoped=true&"
import script from "./policyDetail.vue?vue&type=script&lang=js&"
export * from "./policyDetail.vue?vue&type=script&lang=js&"
import style0 from "./policyDetail.vue?vue&type=style&index=0&id=e9adbf64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9adbf64",
  null
  
)

export default component.exports